import styled from 'styled-components'

export const PanelContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 60px;
  right: ${props => (props.$isOpen ? '0' : '-400px')};
  width: 400px;
  height: calc(100vh - 60px);
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  z-index: 100;
  display: flex;
  flex-direction: column;
`

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f7fafc;
`

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #718096;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #e2e8f0;
    color: #1a202c;
  }
`

export const PanelBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
`

export const Section = styled.div`
  margin-bottom: 2rem;
`

export const SectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.5rem 0;
`

export const SectionDescription = styled.p`
  font-size: 0.875rem;
  color: #718096;
  margin: 0 0 1rem 0;
`

export const FormGroup = styled.div`
  position: relative;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
`

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`

export const CharCount = styled.div`
  position: absolute;
  bottom: -1.25rem;
  right: 0;
  font-size: 0.75rem;
  color: #718096;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 2rem;
`

export const SaveButton = styled.button`
  flex: 1;
  background: #3182ce;
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #2c5282;
  }

  &:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
  }
`

export const ResetButton = styled.button`
  flex: 1;
  background: white;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #f7fafc;
    border-color: #cbd5e0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const SuccessMessage = styled.div`
  padding: 0.75rem;
  background: #c6f6d5;
  color: #22543d;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  animation: slideDown 0.3s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const InfoBox = styled.div`
  background: #edf2f7;
  border-left: 4px solid #3182ce;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
`

export const InfoTitle = styled.h4`
  margin: 0 0 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #2d3748;
`

export const InfoText = styled.p`
  margin: 0;
  font-size: 0.813rem;
  color: #4a5568;
  line-height: 1.5;
`
